import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useToasts } from 'react-toast-notifications';
import { useHistory, useParams, generatePath } from 'react-router';
import constClass from '../../Constants/Constants';

const CustomerRank = (props) => {
  const { user } = props;
  const { siteId, mallId } = useParams();
  const [customerrankData, setCustomerRankData] = useState([]);
  const [lockData, setLockData] = useState(false);
  const { addToast } = useToasts();

  const history = useHistory();

  const [values, setValues] = useState({
    rank_id: null,
    rank_name: '',
    point_give: 0,
    lottery_ticket: 0,
    lottery_ticket_expire_date: 30,
    point_lower: '',
    point_upper: '',
    end_month_flag: constClass.FLAG.ON,
    uploadfile: null,
    uploadfiletype: null,
    deletefile: null,
    notice_title: '',
    notice_alt_text: '',
    notice_detail: '',
    notice_rank_image_url: ''
  });

  const refreshData = useCallback(async () => {
    //トークンを取得
    const jwt = localStorage.getItem('jwt');

    var reg_params = { site_id: siteId };
    const customerrankdata = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/mastercustomerrank/search`, reg_params, {
      headers: {
        Authorization: `Bearer ${jwt}`
      }
    })).data;
    customerrankdata.sort((a, b) => a.point_lower - b.point_lower)
    setCustomerRankData(customerrankdata);
  }, [siteId]);


  /* 編集ボタン押下 */
  const handleUpdateClick = async (data) => {
    var temp = data;
    if (!temp.lottery_ticket) temp.lottery_ticket = 0;
    if (!temp.lottery_ticket) temp.lottery_ticket_expire_date = 30;
    temp.deletefile = null;
    temp.uploadfiletype = null;
    if (data.notice_rank_image_url != null) temp.uploadfile = `/${siteId}/${constClass.NOTICE_RANK_IMAGE_DIR + data.notice_rank_image_url}`;
    else temp.uploadfile = null;
    setValues(temp);
  }

  /* RESETボタン押下 */
  const handleResetClick = () => {
    setValues({
      rank_id: null,
      rank_name: '',
      point_give: 0,
      lottery_ticket: 0,
      lottery_ticket_expire_date: 30,
      point_lower: '',
      point_upper: '',
      end_month_flag: constClass.FLAG.ON,
      uploadfile: "",
      uploadfiletype: "",
      deletefile: "",
      notice_rank_image_url: "",
      notice_title: "",
      notice_alt_text: "",
      notice_detail: "",
    });
  }

  /* DB更新 */
  const handleRegistClick = async (data) => {
    const jwt = localStorage.getItem('jwt');
    console.log(data);
    if (!data.rank_name) {
      window.alert('ランク名称を入力してください。');
      return;
    }
    if (data.rank_name.length > 100) {
      window.alert('ランク名称は、100文字以内で入力してください。');
      return;
    }
    if (!String(data.point_give)) {
      window.alert('ボーナスポイントを入力してください。');
      return;
    }
    if (!(String(data.point_give)).match(/^[0-9]+$/)) {
      window.alert('ボーナスポイントは正の半角整数で入力してください。');
      return;
    }
    if (!String(data.point_lower)) {
      window.alert('獲得ポイント（下限）を入力してください。');
      return;
    }
    if (!(String(data.point_lower)).match(/^[0-9]+$/)) {
      window.alert('獲得ポイント（下限）は正の半角整数で入力してください。');
      return;
    }
    if (data.point_lower.length >= 10) {
      window.alert('獲得ポイント（下限）は10文字未満で入力してください。');
      return;
    }
    if (!data.point_upper) {
      window.alert('獲得ポイント（上限）を入力してください。');
      return;
    }
    if (!(String(data.point_upper)).match(/^[0-9]+$/)) {
      window.alert('獲得ポイント（上限）は正の半角整数で入力してください。');
      return;
    }
    if (data.point_upper.length >= 10) {
      window.alert('獲得ポイント（上限）は10文字未満で入力してください。');
      return;
    }
    if (data.point_upper <= data.point_lower) {
      window.alert('獲得ポイント（下限）が獲得ポイント（上限）に重複または超過しています、再入力してください。');
      return;
    }
    if (!data.lottery_ticket) {
      data.lottery_ticket = 0;
      data.lottery_ticket_expire_date = null;
    }
    if (data.end_month_flag === constClass.FLAG.ON) {
      data.lottery_ticket_expire_date = null;
    }

    var err_msg = null;
    customerrankData.forEach((rankdata) => {
      if (rankdata.rank_id !== data.rank_id) {  //編集対象の範囲はチェックしない
        if ((rankdata.point_lower <= data.point_lower && data.point_lower <= rankdata.point_upper)   //下限の範囲の重複チェック
          || (rankdata.point_lower <= data.point_upper && data.point_upper <= rankdata.point_upper)) { //上限の範囲の重複チェック
          err_msg = `獲得ポイントの上限または下限が重複しています。再入力してください`;
          return;
        }
      }
    })

    if (err_msg !== null) {
      window.alert(err_msg)
      return;
    }

    if (data.rank_id) {
      if (!window.confirm(`ランクID【${data.rank_id}】：「${data.rank_name}」を更新します。よろしいですか？`)) {
        return;
      }
    } else {
      if (!window.confirm(`ランク名称「${data.rank_name}」を登録します。よろしいですか？`)) {
        return;
      }
    }
    if (data.uploadfiletype === null) data.uploadfile = null;

    var params = data;
    params.ins_name = user.userId;
    params.upd_name = user.userId;
    params.site_id = siteId;

    let res;
    try {
      setLockData(true);
      if (data.rank_id === null) {
        res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/mastercustomerrank/`, params, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        });
      } else {
        res = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/mastercustomerrank/${data.rank_id}`, params, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        });
      }
    } catch (err) {
      console.log(err);
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (!res) {
      } else if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('登録しました。', { appearance: 'success', autoDismiss: true });
        await refreshData();
      }
      setLockData(false);
      handleResetClick();
    }
  }
  /* DB削除 */
  const handleDeleteClick = async (data) => {
    const jwt = localStorage.getItem('jwt');

    if (!window.confirm(`ランクID[${data.rank_id}]:${data.rank_name}を削除します。よろしいですか？`)) {
      return;
    }
    const params = {
      site_id: siteId,
      rank_id: data.rank_id,
      rank_name: data.rank_name,
      point_lower: data.point_lower,
      point_upper: data.point_upper,
      upd_date: data.upd_date
    };
    let res;
    try {
      setLockData(true);
      res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/mastercustomerrank/delete/`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      });
    } catch (err) {
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('削除しました。', { appearance: 'success', autoDismiss: true });
        await refreshData();
      }
      setLockData(false);
      handleResetClick();
    }
  }

  const renderBenefitSettingsButton = () => {
    return (
      <button
        className={`my-3 align-self-center text-right btn btn-primary mx-2`}
        onClick={() => history.push(`${generatePath(`${props.match.path}`, { siteId, mallId })}benefitlotteryticket`)}>
        特典設定
      </button>
    )
  }

  const renderLotteryButton = () => {
    return (
      <button
        className={`my-3 align-self-center text-right btn btn-primary mx-2`}
        onClick={() => history.push(`${generatePath(`${props.match.path}`, { siteId, mallId })}lottery`)}>
        抽選
      </button>
    )
  }

  const renderUpdateButton = (data) => {
    return (
      <button
        className={`btn btn-primary mx-1`}
        onClick={() => handleUpdateClick(data)}>
        編集
      </button>
    )
  }

  const renderRegistButton = (data) => {
    return (
      <button type="button"
        disabled={lockData}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleRegistClick(data)}>
        登録
      </button>
    )
  }

  const renderDeleteButton = (data) => {
    return (
      <button type="button"
        disabled={lockData || data.rank_id === null}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleDeleteClick(data)}>
        削除
      </button>
    )
  }

  const renderResetButton = () => {
    return (
      <button type="button"
        disabled={false}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleResetClick()}>
        リセット
      </button>
    )
  }

  const handleChange = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? (target.checked ? constClass.FLAG.ON : constClass.FLAG.OFF) : target.value;
    const name = target.name;
    setValues({ ...values, [name]: value });
  }

  const handleChangeFile = (e) => {
    const value = e.target.files[0];
    var reader = new FileReader();
    reader.onloadend = () => {
      setValues({
        ...values,
        uploadfile: reader.result,
        uploadfiletype: value.type,
        deletefile: values.notice_rank_image_url
      });
    }
    reader.readAsDataURL(value);
  }

  const handleDeleteFile = () => {
    setValues({ ...values, uploadfile: null, uploadfiletype: null, deletefile: values.notice_rank_image_url });
  }


  useEffect(() => {
    refreshData();
  }, [refreshData]); //

  const renderInput = () => {
    return (
      <div className="mx-1">
        <div className="row mb-3">
          <div className="col-4 text-center align-self-center">
            <span>ランクID</span>
          </div>
          <div className="col-4 text-center align-self-center">
            <input type="text" className="form-control w-100" name="rank_id" defaultValue={values.rank_id} placeholder="新規" readOnly />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-4 text-center align-self-center">
            <span>ランク名称</span>
          </div>
          <div className="col-4 text-center align-self-center">
            <input type="text" className="form-control w-100" name="rank_name" value={values.rank_name || ""} onChange={handleChange} placeholder="ランク名称を入力してください" />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-4 text-center align-self-center">
            <span>ボーナスポイント</span>
          </div>
          <div className="col-3 text-center align-self-center">
            <input type="text" className="form-control w-75" name="point_give" value={values.point_give} onChange={handleChange} placeholder="ボーナスポイントを入力してください" />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-4 text-center align-self-center">
            <span>抽選券付与数</span>
          </div>
          <div className="col-3 text-center align-self-center">
            <input type="text" className="form-control w-75" name="lottery_ticket" value={values.lottery_ticket} onChange={handleChange} placeholder="抽選券付与数を入力してください" />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-4 text-center align-self-center">
            <label htmlFor="end_month_flag">抽選券の有効期限（付与日から当月末まで）</label>
          </div>
          <div className="col-3 text-center align-self-center">
            <input type="checkbox" className="form-control w-25" name="end_month_flag" value="true" checked={values.end_month_flag === constClass.FLAG.ON} onChange={handleChange}></input>
          </div>
        </div>
        {values.end_month_flag !== constClass.FLAG.ON &&
          <div className="row mb-3">
            <div className="col-4 text-center align-self-center">
              <span>抽選券の有効期限（付与日から〇日間）</span>
            </div>
            <div className="col-3 text-center align-self-center">
              <input type="text" className="form-control w-75" name="lottery_ticket_expire_date" value={values.lottery_ticket_expire_date} onChange={handleChange} placeholder="抽選券有効期限を入力してください" disabled={values.lottery_ticket <= 0} />
            </div>
          </div>
        }
        <div className="row mb-3">
          <div className="col-4 text-center align-self-center">
            <span>獲得ポイント（下限）</span>
          </div>
          <div className="col-3 text-center align-self-center">
            <input type="text" className="form-control w-75" name="point_lower" value={values.point_lower} onChange={handleChange} placeholder="ポイント（下限）を入力してください" />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-4 text-center align-self-center">
            <span>獲得ポイント（上限）</span>
          </div>
          <div className="col-3 text-center align-self-center">
            <input type="text" className="form-control w-75" name="point_upper" value={values.point_upper} onChange={handleChange} placeholder="ポイント（上限）を入力してください" />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-12 text-center align-self-center">
            <span>毎年４月１日に、昨年４月１日＝今年３月３１日までの獲得ポイントを集計します。集計結果をもとにランクを決定し、毎年５月１日に該当ランクのボーナスポイントを付与します。</span>
          </div>
        </div>
        <div className="notice-margin">
          <div className="col-12 mb-4 text-center align-self-center">
            設定しない場合は、システムであらかじめ用意されたランク通知タイトル、ランク通知テキスト、ランク通知詳細、ランク決定時画像が表示されます。
          </div>
          <div className="row mb-3">
            <div className="col-4 text-center align-self-center">
              <label htmlFor="notice_title">ランク通知タイトル</label>
            </div>
            <div className="col-3 align-self-center">
              <input type="text" className="form-control" name="notice_title" id="notice_title" value={values.notice_title || ""} placeholder="ランク通知時のタイトル" onChange={handleChange} />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-4 text-center align-self-center">
              <label htmlFor="notice_alt_text">ランク通知テキスト</label>
            </div>
            <div className="col-3 align-self-center">
              <input type="text" className="form-control" name="notice_alt_text" id="notice_alt_text" value={values.notice_alt_text || ""} placeholder="ランク通知時のテキスト" onChange={handleChange} />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-4 text-center align-self-center">
              <label htmlFor="notice_detail">ランク通知詳細</label>
            </div>
            <div className="col-3 align-self-center">
              <textarea className="form-control" rows="2" name="notice_detail" id="notice_detail" value={values.notice_detail || ""} placeholder="ランク通知時の詳細" onChange={handleChange}></textarea>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-4 text-center align-self-center">
              <label htmlFor="notice_rank_image_url">ランク決定時画像</label>
            </div>
            <div className="col-3 align-self-center">
              {!(values.uploadfile) && <input type="file" className="form-control-file" name="notice_rank_image_url" id="notice_rank_image_url" value="" onChange={handleChangeFile} onClick={e => (e.target.value = null)} />}
              {values.uploadfile && <object id="uploadfileview3" className="w-100" data={values.uploadfile} type={values.uploadfiletype}><img className="w-100" src={values.uploadfile} alt='uploadfile' /></object>}
              {values.uploadfile && <input type="button" className="form-controll" name="deletefile" id="deletefile" onClick={handleDeleteFile} value="ファイル削除" />}
            </div>
          </div>
        </div>
        <span className="text-danger"></span>
        <div className="row mb-2 pb-4">
          <div className="col-4 text-center">
            {renderRegistButton(values)}
          </div>
          <div className="col-4 text-center">
            {renderDeleteButton(values)}
          </div>
          <div className="col-4 text-center">
            {renderResetButton(values)}
          </div>
        </div>
      </div>
    );
  }

  const renderList = () => {
    return (
      <div className="row mb-3 mt-3 p-0">
        <div className="col-12 p-0">
          <div className="d-flex justify-content-end mr-4">
            {renderLotteryButton()}
            {renderBenefitSettingsButton()}
          </div>
          <table className="table table-bordered table-striped">
            <thead className={`table-info`}>
              <tr>
                <td className="text-center align-middle">
                  ランクID
                </td>
                <td className="text-center align-middle">
                  ランク名称
                </td>
                <td className="text-center align-middle">
                  ボーナスポイント
                </td>
                <td className="text-center align-middle">
                  獲得ポイント（下限）
                </td>
                <td className="text-center align-middle">
                  獲得ポイント（上限）
                </td>
                <td className="text-center align-middle">
                  処理
                </td>
              </tr>
            </thead>
            <tbody>
              {customerrankData.map((data, idx) => (
                <tr key={idx}>
                  {/* ランクID */}
                  <td className="text-center align-middle">
                    {data.rank_id}
                  </td>
                  {/* ランク名称 */}
                  <td className="text-center align-middle">
                    {data.rank_name}
                  </td>
                  {/* ボーナスポイント */}
                  <td className="text-center align-middle">
                    {data.point_give}
                  </td>
                  {/* 獲得ポイント（下限） */}
                  <td className="text-center align-middle">
                    {data.point_lower}
                  </td>
                  {/* 獲得ポイント（上限） */}
                  <td className="text-center align-middle">
                    {data.point_upper}
                  </td>
                  {/* 処理 */}
                  <td className="text-center align-middle text-nowrap">
                    {renderUpdateButton(data)}
                  </td>
                </tr>
              ))
              }
            </tbody>
          </table>
        </div>
      </div>
    );
  }
  return (
    <div className="container">
      {customerrankData === null && <div className="row"><div className="col-12">読み込み中・・・</div></div>}
      {customerrankData !== null && (renderList())}
      {renderInput()}
    </div>
  )
}

export default CustomerRank;